// extracted by mini-css-extract-plugin
export default {"main":"perfwrite_main__RDn4d","title":"perfwrite_title__Ax3bo"};